const StreamedEvents = require('../report/StreamedEvents');
const LicenseInfo = require('../report/LicenseInfo');
const View = require('../../../../_lib/core/View');

class SongSubmissionView extends View {
  constructor() {
    super('song-submission');

    this.licenseTypeSelect = $('.select-licenseType');
    this.licenseTypeContainer = $('.license-type-container');
    this.weeksSelect = $('.time-report');

    this.streamedEvents = new StreamedEvents(this, $('select[name=streamed_events]'));
    this.licenseInfo = new LicenseInfo(this);
  }
}

module.exports = SongSubmissionView;
